<template>
  <b-container fluid id="mfLandingContainer" class="pb-5">
    <b-row class=" justify-content-center align-items-center">
      <b-col cols="12">
        <b-row class=" justify-content-center align-items-center">
          <div class="title">
            Be the Financial Advisor savers deserve
          </div>
        </b-row>
        <Row>
          <div class="subtitle">
            Empower your customers by helping them optimize their risks, fees, and carbon impacts.
          </div>
        </Row>
        <Row>
          <div class="subtitle">
            Access and replicate the industry leader strategy seamlessly
          </div>
        </Row>
        <Row>
          <b-col sm="10" md="8" lg="12">
            <form method="POST" :action="route">
              <input type="hidden" name="_token" :value="token" />
              <div class="inputGroup"><input type="email" placeholder="votre@email.com" /><button type="submit">Request access</button></div>
            </form>
          </b-col>
        </Row>
      </b-col>
    </b-row>

    <!-- <div style="display: flex; justify-content: space-between">
      <div style="display: flex">
        <div class="title">myfo</div>
        <div class="cryptoWord">CRYPTO</div>
      </div>
      <div>
        <button class="btnLogin">Login</button>
      </div>
    </div>
    <Row>
      <b-col md="6" sm="12">
        <Row>
          <div class="title">
            Your crypto trading advisor
          </div>
        </Row>
        <Row>
          <div class="subtitle">
            Seamlessly plug to your exchange, get insights to improve your returns
          </div>
        </Row>
        <Row>
          <div class="inputGroup"><input type="email" placeholder="votre@email.com" /><button>Join our waiting list</button></div>
        </Row>
        <Row></Row>
      </b-col>
      <b-col md="6" sm="12">
        <img src="./comps/img/lacovermyfo-01.png" alt="lacovermyfo-01" style="width: 75%" />
      </b-col>
    </Row> -->
  </b-container>
</template>
<script>
import Row from "./comps/Row.vue";
import BlocSmBlue from "./comps/BlocSmBlue.vue";
import QuestCollapse from "./comps/questCollapse.vue";
import ModalSecurity from "./comps/ModalSecurity.vue";
import ModalLogin from "./comps/ModalLogin.vue";

export default {
  props: ['route'],
  components: {
    Row,
    ModalLogin,
    BlocSmBlue,
    QuestCollapse,
    ModalSecurity,
  },
  mounted() {
    console.log(this.route);
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

#mfLandingContainer {
  color: $mf_ft_color_white;
  background: #0d0221;
  padding: 20px;
  min-height: 70vh;
  height: 92.5vh;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  align-content: center;

  background-image: url("./comps/Courbe fond.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  .cryptoWord {
    text-align: left;
    font: normal normal bold $mf_ft_size_text Baloo;
    letter-spacing: 0px;
    color: #9bbdf9;
    opacity: 1;
  }

  .inputGroup {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    input {
      border-width: 2px;
      border-color: #9bbdf9;
      border-radius: 5px;
      color: #9bbdf9;
      background: transparent;
      padding: 3px;
      width: 100%;
      font-weight: bold;
    }
    button {
      border-radius: 5px;
      background: #9bbdf9;
      border: none;
      font-weight: bold;
      padding: 5px;
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      margin-left: -5px;
    }
  }

  .title {
    text-align: center;
    font: normal normal bold $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .subtitle {
    font: normal normal normal $mf_ft_size_text Dosis;
    text-align: center;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
    span {
      color: $blue_color;
    }
  }
  .textExplain {
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
    span {
      color: $blue_color;
    }
  }

  .trustPilotImg {
    @media (max-width: 576px) {
      width: 80%;
    }
    @media (min-width: 576px) {
      width: 40%;
    }
    @media (min-width: 1200px) {
      width: 20%;
    }
  }
  .mf_landing_apostrophe {
    @media (max-width: 576px) {
      width: 100%;
    }
    @media (min-width: 576px) {
      width: 40%;
    }
  }
  .mf_landing_apostrophe_right {
    position: relative;
    bottom: -80px;
    @media (min-width: 768) {
      bottom: -40px;
    }
  }
  .mf_landing_apostrophe_left {
    position: relative;
    top: -80px;
    @media (min-width: 768) {
      top: -40px;
    }
  }
  .titleExplainBLoc {
    .title {
      text-align: center;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: #635bff;
    }
    .subtitle {
      text-align: center;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
    }
  }
  .mf_landing_hr {
    width: 80%;
    margin: auto;
  }
  .mf_landing_firstBigImg {
    @media (min-width: 768px) {
      width: 56%;
      position: absolute;
      right: 0px;
      bottom: 15px;
    }
    @media (max-width: 768px) {
      position: relative;
      right: 0px;
      width: 100%;
    }
  }
  .mf_landing_quest_card {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    padding: 20px;
  }
  .mf_landing_partenaire_img {
    width: 50%;
    padding: 20px;
  }
}

ul {
  padding-left: 1em;
}
.bgPurple {
  background: $purple_color !important;
}
.txtVlt {
  color: $mf_ft_color_vlt;
}

.txtPurple {
  color: $purple_color;
}

.txtBlue {
  color: $blue_color;
}

.txtLeft {
  text-align: left;
}

.imgContent {
  width: 80%;
  height: 100%;
}

.colHCenter {
  align-self: center;
}
</style>
